import { IIsland } from 'declarations/island';
import { makeAutoObservable } from 'mobx';

export class IslandStore {

  values: Array<IIsland> = [];
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  addValues(values: Array<IIsland>): void {
    this.values = values;
  }

  setLoading(val: boolean) {
    this.loading = val;
  }
}

export default (new IslandStore())

